import { Box, Button, Dialog, Grid, Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

function ResetConfirmDialog({isOpen, doReturn, doReset}) {

  const handleClickReturn = (_) => {
    doReturn();
  }

  const handleClickReset = (_) => {
    doReset();
  }

  return (
    <Dialog
      open={isOpen}
    >
      <Box m={2} width={370}>
        <Typography fontSize={20} fontWeight='bold' mb={2}>
          確認
        </Typography>
        <Typography my={2}>
          選択された原票情報が存在します。更新しますか？
        </Typography>
        <Grid container columnSpacing={2}>
          <Grid item xs textAlign='right'>
            <Button
              variant="contained"
              color="error"
              onClick={handleClickReturn}
            >
              再検索せず戻る
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickReset}
            >
              選択をクリアして再検索する
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}

export default ResetConfirmDialog;